/* ============================================================
   BEST LOGO MATS™ — Configurator v5 (Native Shopify Checkout)
   Uses Shopify Cart API — no contact forms, real payment
   bestlogomats.com | 321.751.4636
   ============================================================ */

/* ── Helpers ── */
function el(id){ return document.getElementById(id); }
function txt(id,v){ var e=el(id); if(e) e.textContent=v; }

/* ── Variant cache (Shopify product JSON) ── */
var variantCache = {};

/* ── State ── */
var S = {
  use:        'indoor',
  handle:     'crystalprint-hd',
  variantId:  null,       // Shopify variant ID — fetched via API
  nm:         'CrystalPrint HD\u2122',
  sz:         null,       // selected size label e.g. "2\u2019 \xd7 3\u2019"
  szKey:      null,       // size key for variant lookup
  price:      245,
  qty:        1,
  color:      '#003087',
  colorName:  'Navy Blue',
  file:       '',
  fd:         false,
  img:        null,
  uploadedDataUrl: null   // for sending with order
};

/* ── Product handle map — matches Shopify product handles ── */
var MATS = {
  indoor: [
    {handle:'crystalprint-hd',  nm:'CrystalPrint HD\u2122',   price:245, badge:'Best Seller',      img:'https://cdn.shopify.com/s/files/1/0727/3453/9975/files/DigiPrintHD-SolidColor-Corner-Web_de2ba4ba-07ff-48ea-b004-c22fd11ab066.jpg?v=1771168499'},
    {handle:'aquashield-hd',    nm:'AquaShield HD\u2122',      price:339, badge:'',                 img:'https://cdn.shopify.com/s/files/1/0727/3453/9975/files/WaterHogImpressionsHDLogoMat-WebsiteThumbnail_30418fc5-0d11-446e-a54f-8f1c3339d1b4.jpg?v=1771173724'},
    {handle:'ecovivid',         nm:'EcoVivid\u2122',           price:192, badge:'Eco',              img:'https://cdn.shopify.com/s/files/1/0727/3453/9975/files/ColorStarImpressions-AdvanceAutoParts-IsolatedFullAbove-web_b49d8f13-073c-4498-ace8-c74db3a2f0c7.jpg?v=1771109920'},
    {handle:'berberhd',         nm:'BerberHD\u2122',           price:159, badge:'',                 img:'https://cdn.shopify.com/s/files/1/0727/3453/9975/files/BerberImpressions-isolatedfullabove-web-Promenade_21d6e29c-fce8-4a8b-9329-17b1e45952ff.jpg?v=1771109138'},
  ],
  outdoor: [
    {handle:'stormguard-pro',   nm:'StormGuard Pro\u2122',     price:214, badge:'#1 Outdoor',       img:'https://cdn.shopify.com/s/files/1/0727/3453/9975/files/SuperScrapeImpressions-isolatedflat-FiestaGrille-website900x600_d66412ba-a270-4bf5-9b92-b2212a8d2676.jpg?v=1771172796'},
    {handle:'aquashield-elite', nm:'AquaShield Elite\u2122',   price:249, badge:'Top Rated',        img:'https://cdn.shopify.com/s/files/1/0727/3453/9975/files/WaterhogInlay-SevenApartments-IsolatedFullAbove-web_81afa1ff-e322-4ddb-a5a0-fd8d89686fa3.jpg?v=1771174422'},
    {handle:'swiftscrape',      nm:'SwiftScrape\u2122',        price:84,  badge:'',                 img:'https://cdn.shopify.com/s/files/1/0727/3453/9975/files/POPScrapeImpressions-KrakenRum-IsolatedFlatAbove-Web_d5e482d3-fedf-40e2-b120-794c06509ab5.jpg?v=1771172008'}
  ],
  fatigue: [
    {handle:'comfortprint',     nm:'ComfortPrint\u2122',       price:258, badge:'Most Comfortable', img:'https://cdn.shopify.com/s/files/1/0727/3453/9975/files/HogHeavenImpressions-XeroxDesign-isolatedfullabove-web_6ba72681-e648-47a8-a056-1e7bbacfc0bf.jpg?v=1771171002'},
    {handle:'comfortprint-runner',nm:'ComfortPrint\u2122 Runner',price:258,badge:'',                img:'https://cdn.shopify.com/s/files/1/0727/3453/9975/files/BrandComfort-Lido-IsolatedFlatAbove-Web.jpg?v=1771109631'}
  ],
  event: [
    {handle:'quickbrand',       nm:'QuickBrand\u2122',         price:229,  badge:'Best Value',       img:'https://cdn.shopify.com/s/files/1/0727/3453/9975/files/POP-FreightLiner-IsolatedFullAbove-web_a3913bbd-8998-49eb-9abe-6c5d8dc28aab.jpg?v=1771171735'},
    {handle:'impactfloor',      nm:'ImpactFloor\u2122',        price:149, badge:'',                 img:'https://cdn.shopify.com/s/files/1/0727/3453/9975/files/FloorImpressions-inplace-ColoradoLottery_718afadf-4c4e-44ca-81f3-2fe5c723941e.jpg?v=1771170003'},
    {handle:'swiftscrape',      nm:'SwiftScrape\u2122',        price:84,  badge:'',                 img:'https://cdn.shopify.com/s/files/1/0727/3453/9975/files/POPScrapeImpressions-KrakenRum-IsolatedFlatAbove-Web_d5e482d3-fedf-40e2-b120-794c06509ab5.jpg?v=1771172008'}
  ]
};

var TEX = {
  'crystalprint-hd':'carpet', 'aquashield-hd':'waffle', 'aquashield-elite':'waterhog',
  'ecovivid':'carpet', 'berberhd':'berber', 'stormguard-pro':'scraper',
  'swiftscrape':'scraper', 'comfortprint':'foam', 'comfortprint-runner':'foam',
  'quickbrand':'fabric', 'impactfloor':'rubber'
};

/* ── Complete price table: handle → {size label → price} ── */
var PRICES = {
  'crystalprint-hd':   { "2\u2019 \xd7 3\u2019":245, "3\u2019 \xd7 4\u2019":274, "3\u2019 \xd7 5\u2019":286, "4\u2019 \xd7 6\u2019":366, "3\u2019 \xd7 10\u2019":472, "4\u2019 \xd7 8\u2019":504, "5\u2019 \xd7 8\u2019":593, "5\u2019 \xd7 10\u2019":726, "6\u2019 \xd7 10\u2019":784, "6\u2019 \xd7 12\u2019":940 },
  'aquashield-hd':     { "2\u2019 \xd7 3\u2019":249, "3\u2019 \xd7 5\u2019":286, "4\u2019 \xd7 6\u2019":366, "4\u2019 \xd7 8\u2019":504, "6\u2019 \xd7 10\u2019":784, "6\u2019 \xd7 12\u2019":940 },
  'aquashield-elite':  { "2\u2019 \xd7 3\u2019":249, "3\u2019 \xd7 4\u2019":298, "3\u2019 \xd7 5\u2019":309, "4\u2019 \xd7 6\u2019":366, "3\u2019 \xd7 10\u2019":487, "4\u2019 \xd7 8\u2019":498, "4\u2019 \xd7 10\u2019":573, "4\u2019 \xd7 12\u2019":698, "6\u2019 \xd7 10\u2019":784, "6\u2019 \xd7 12\u2019":1037, "6\u2019 \xd7 16\u2019":1334, "6\u2019 \xd7 20\u2019":1549 },
  'ecovivid':          { "2\u2019 \xd7 3\u2019":245, "3\u2019 \xd7 4\u2019":274, "3\u2019 \xd7 5\u2019":286, "4\u2019 \xd7 6\u2019":366, "3\u2019 \xd7 10\u2019":472, "4\u2019 \xd7 8\u2019":504, "5\u2019 \xd7 8\u2019":593, "5\u2019 \xd7 10\u2019":726, "6\u2019 \xd7 10\u2019":784, "6\u2019 \xd7 12\u2019":940 },
  'berberhd':          { "2\u2019 \xd7 3\u2019":245, "3\u2019 \xd7 4\u2019":274, "3\u2019 \xd7 5\u2019":286, "4\u2019 \xd7 6\u2019":366, "3\u2019 \xd7 10\u2019":472, "4\u2019 \xd7 8\u2019":504, "5\u2019 \xd7 8\u2019":593, "5\u2019 \xd7 10\u2019":726, "6\u2019 \xd7 10\u2019":784, "6\u2019 \xd7 12\u2019":940 },
  'stormguard-pro':    { "3\u2019 \xd7 4\u2019":213, "4\u2019 \xd7 6\u2019":229, "4\u2019 \xd7 8\u2019":504, "6\u2019 \xd7 8\u2019":784 },
  'swiftscrape':       { "3\u2019 \xd7 5\u2019":154, "4\u2019 \xd7 6\u2019":229 },
  'comfortprint':      { "2\u2019 \xd7 3\u2019":258, "3\u2019 \xd7 5\u2019":349, "4\u2019 \xd7 6\u2019":475 },
  'comfortprint-runner':{ "2\u2019 \xd7 3\u2019":258, "2\u2019 \xd7 6\u2019":348 },
  'quickbrand':        { "3\u2019 \xd7 5\u2019":318, "4\u2019 \xd7 6\u2019":229 },
  'impactfloor':       { "4\u2019 \xd7 6\u2019":229, "3\u2019 \xd7 4\u2019":213, "4\u2019 \xd7 8\u2019":475 },
};

/* ── Volume discount tiers ── */
var VOL_TIERS = [
  { min:1,  max:1,  pct:0,  label:'1 mat'      },
  { min:2,  max:10, pct:10, label:'2–10 mats'  },
  { min:11, max:25, pct:15, label:'11–25 mats' },
  { min:26, max:999,pct:20, label:'26+ mats'   }
];

function getVolDiscount(qty) {
  for (var i = VOL_TIERS.length - 1; i >= 0; i--) {
    if (qty >= VOL_TIERS[i].min) return VOL_TIERS[i].pct;
  }
  return 0;
}

function getDiscountedTotal(basePrice, qty) {
  var pct = getVolDiscount(qty);
  var gross = basePrice * qty;
  return pct > 0 ? Math.round(gross * (1 - pct/100)) : gross;
}

/* ── Size definitions — all possible sizes across all products ── */
var ALL_SIZES = [
  { lbl:"2\u2019 \xd7 3\u2019",  sz:'2x3'  },
  { lbl:"3\u2019 \xd7 4\u2019",  sz:'3x4'  },
  { lbl:"3\u2019 \xd7 5\u2019",  sz:'3x5'  },
  { lbl:"4\u2019 \xd7 6\u2019",  sz:'4x6'  },
  { lbl:"3\u2019 \xd7 10\u2019", sz:'3x10' },
  { lbl:"4\u2019 \xd7 8\u2019",  sz:'4x8'  },
  { lbl:"4\u2019 \xd7 10\u2019", sz:'4x10' },
  { lbl:"4\u2019 \xd7 12\u2019", sz:'4x12' },
  { lbl:"5\u2019 \xd7 8\u2019",  sz:'5x8'  },
  { lbl:"5\u2019 \xd7 10\u2019", sz:'5x10' },
  { lbl:"6\u2019 \xd7 8\u2019",  sz:'6x8'  },
  { lbl:"6\u2019 \xd7 10\u2019", sz:'6x10' },
  { lbl:"6\u2019 \xd7 12\u2019", sz:'6x12' },
  { lbl:"6\u2019 \xd7 16\u2019", sz:'6x16' },
  { lbl:"6\u2019 \xd7 20\u2019", sz:'6x20' },
  { lbl:"2\u2019 \xd7 6\u2019",  sz:'2x6'  }
];

/* ── Look up the correct price given current mat + size ── */
function getPrice(handle, szLabel) {
  if (!handle || !szLabel) return 0;
  var table = PRICES[handle];
  if (!table) return 0;
  return table[szLabel] || 0;
}

/* ── Get base "from" price for a mat (lowest size price) ── */
function getBasePrice(handle) {
  var table = PRICES[handle];
  if (!table) return 0;
  var vals = Object.values ? Object.values(table) : Object.keys(table).map(function(k){ return table[k]; });
  return vals.length ? Math.min.apply(null, vals) : 0;
}

/* ── Rebuild size buttons for the currently selected mat ── */
function renderSizes() {
  var wrap = document.getElementById('sz-wrap');
  if (!wrap) return;

  var table  = S.handle ? (PRICES[S.handle] || {}) : {};
  var hasSz  = Object.keys(table).length > 0;

  var html = ALL_SIZES.map(function(s) {
    var price = table[s.lbl];
    if (!price) return '';   // hide sizes not available for this mat
    var sel = (S.szKey === s.lbl) ? ' on' : '';
    return '<button class="sbtn' + sel + '" data-sz="' + s.sz + '" data-lbl="' + s.lbl + '" data-p="' + price + '">'
      + s.lbl + '<em>$' + price + '</em></button>';
  }).join('');

  /* Always add custom size at end */
  html += '<button class="sbtn sbtn-custom" data-sz="custom" data-lbl="Custom Size" data-p="0" onclick="openCustomQuote(event)">Custom Size<em>Get a Quote \u2192</em></button>';

  wrap.innerHTML = html;

  /* If currently selected size isn't available for new mat, deselect it */
  if (S.szKey && !table[S.szKey]) {
    S.szKey  = null;
  }
  /* If no size selected yet, auto-select the first/cheapest */
  if (!S.szKey && hasSz) {
    var first = ALL_SIZES.find(function(s){ return !!table[s.lbl]; });
    if (first) {
      S.szKey  = first.lbl;
      S.price  = table[first.lbl];
      /* Mark that button as selected */
      var firstBtn = wrap.querySelector('[data-lbl="' + first.lbl + '"]');
      if (firstBtn) firstBtn.classList.add('on');
    }
  }
}

/* ════════════════════════════════════════════════════════════
   SHOPIFY VARIANT LOOKUP
   Fetches product JSON to get variant IDs for cart API
════════════════════════════════════════════════════════════ */
function fetchVariants(handle, callback) {
  if (variantCache[handle]) { callback(variantCache[handle]); return; }
  fetch('/products/' + handle + '.js')
    .then(function(r){ return r.json(); })
    .then(function(product){
      var variants = product.variants.map(function(v){
        return { id: v.id, title: v.title, price: v.price/100 };
      });
      variantCache[handle] = variants;
      callback(variants);
    })
    .catch(function(){ callback([]); });
}

function pickVariant(variants, szLabel) {
  /* Match by size label — tries exact, then fuzzy */
  if (!szLabel) return variants[0] || null;
  var exact = variants.find(function(v){ return v.title === szLabel; });
  if (exact) return exact;
  /* Fuzzy: strip spaces/apostrophes */
  var clean = function(s){ return s.replace(/[\s'×x]/g,'').toLowerCase(); };
  var fuzzy = variants.find(function(v){ return clean(v.title) === clean(szLabel); });
  return fuzzy || variants[0] || null;
}

/* ════════════════════════════════════════════════════════════
   ADD TO SHOPIFY CART — native /cart/add.js
   Line item properties carry all customization details
════════════════════════════════════════════════════════════ */
function addToCart() {
  var btn = el('checkout-btn');

  /* Validate: mat selected */
  if (!S.handle) {
    showError('Please select a mat style first (Step 2).');
    return;
  }
  /* Validate: size selected */
  if (!S.szKey) {
    showError('Please select a size (Step 3).');
    return;
  }

  /* Loading state */
  setBtn(btn, '⏳ Adding to cart...', true);

  /* Build line item properties — all customization goes here */
  /* Shopify passes these through to order emails + admin     */
  var props = {
    'Mat Type':        S.nm,
    'Use':             {indoor:'Indoor',outdoor:'Outdoor',fatigue:'Anti-Fatigue',event:'Event/POP'}[S.use]||S.use,
    'Size':            S.szKey,
    'Color':           S.colorName,
    'Artwork':         S.file || (S.fd ? 'Free design requested' : 'Customer will email artwork'),
    'Design Notes':    (el('design-notes')||{}).value || 'None',
    '_Proof Required': 'YES — Send proof to customer within 24 hrs before production'
  };

  fetchVariants(S.handle, function(variants){
    var variant = pickVariant(variants, S.szKey);

    if (!variant) {
      /* Product not in Shopify yet — fall back to contact form */
      setBtn(btn, 'Order Free Proof \u2192', false);
      showError('This product isn\u2019t live in your store yet. Import the products CSV first, or contact us directly.');
      return;
    }

    /* Add to cart */
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: variant.id,
        quantity: S.qty,
        properties: props
      })
    })
    .then(function(r){
      if (!r.ok) throw new Error('Cart add failed: ' + r.status);
      return r.json();
    })
    .then(function(){
      setBtn(btn, '\u2713 Added! Going to checkout...', false);
      btn.style.background = '#16a34a';
      /* Go straight to checkout — skip cart page */
      setTimeout(function(){ window.location.href = '/checkout'; }, 800);
    })
    .catch(function(err){
      console.error('[BLM] Cart error:', err);
      setBtn(btn, 'Order Free Proof \u2192', false);
      showError('Something went wrong. Please call us at 321.751.4636 or try again.');
    });
  });
}

function setBtn(btn, text, disabled) {
  if (!btn) return;
  btn.textContent = text;
  btn.disabled = disabled;
  if (!disabled) btn.style.background = '';
}

function showError(msg) {
  var e = el('checkout-error');
  if (!e) return;
  e.textContent = msg;
  e.style.display = 'block';
  setTimeout(function(){ e.style.display = 'none'; }, 6000);
}

/* ════════════════════════════════════════════════════════════
   CANVAS DRAW
════════════════════════════════════════════════════════════ */
function draw() {
  var cv = el('cv');
  if (!cv) return;
  var ctx = cv.getContext('2d');
  var W = cv.width, H = cv.height;
  var bg  = S.color || '#003087';
  var bdr = lighten(bg, 40);
  var ac  = lighten(bg, 25);
  var tx  = TEX[S.handle] || 'carpet';

  ctx.clearRect(0,0,W,H);
  ctx.fillStyle='#06101e'; ctx.fillRect(0,0,W,H);
  ctx.strokeStyle='rgba(255,255,255,.03)'; ctx.lineWidth=1;
  for(var gx=0;gx<W;gx+=40){ctx.beginPath();ctx.moveTo(gx,0);ctx.lineTo(gx,H);ctx.stroke();}
  for(var gy=0;gy<H;gy+=40){ctx.beginPath();ctx.moveTo(0,gy);ctx.lineTo(W,gy);ctx.stroke();}

  var szRatios = {"2\u2019 \xd7 3\u2019":.67,"3\u2019 \xd7 4\u2019":.75,"3\u2019 \xd7 5\u2019":.60,"4\u2019 \xd7 6\u2019":.67,"4\u2019 \xd7 8\u2019":.50,"5\u2019 \xd7 8\u2019":.63,"6\u2019 \xd7 10\u2019":.60};
  var ratio = (S.szKey && szRatios[S.szKey]) || .67;
  var mW,mH,mxW=W*.84,mxH=H*.80;
  if(mxW*ratio>mxH){mH=mxH;mW=mH/ratio;}else{mW=mxW;mH=mW*ratio;}
  var mx=(W-mW)/2, my=(H-mH)/2, cr=10;

  ctx.shadowColor='rgba(0,0,0,.75)'; ctx.shadowBlur=24; ctx.shadowOffsetY=10;
  rrect(ctx,mx,my,mW,mH,cr); ctx.fillStyle=bg; ctx.fill();
  ctx.shadowColor='transparent'; ctx.shadowBlur=0; ctx.shadowOffsetY=0;

  drawTex(ctx,tx,mx,my,mW,mH,ac);
  rrect(ctx,mx,my,mW,mH,cr); ctx.strokeStyle=bdr; ctx.lineWidth=3; ctx.stroke();
  rrect(ctx,mx+7,my+7,mW-14,mH-14,cr-2); ctx.strokeStyle='rgba(255,255,255,.08)'; ctx.lineWidth=1; ctx.stroke();

  var szScale = {"2\u2019 \xd7 3\u2019":.72,"3\u2019 \xd7 4\u2019":.75,"3\u2019 \xd7 5\u2019":.77,"4\u2019 \xd7 6\u2019":.80,"4\u2019 \xd7 8\u2019":.82,"5\u2019 \xd7 8\u2019":.83,"6\u2019 \xd7 10\u2019":.85};
  var sc=(S.szKey&&szScale[S.szKey])||.78;

  if(S.img){
    var ir=S.img.naturalWidth/S.img.naturalHeight,lmW=mW*sc,lmH=(mH-20)*sc,lW,lH;
    if(lmW/ir>lmH){lH=lmH;lW=lH*ir;}else{lW=lmW;lH=lW/ir;}
    if(lH>mH-28){lH=mH-28;lW=lH*ir;}
    ctx.globalAlpha=.92;ctx.drawImage(S.img,mx+(mW-lW)/2,my+(mH-lH)/2-6,lW,lH);ctx.globalAlpha=1;
  } else {
    var pw=mW*sc,ph=(mH-28)*.72;if(ph<48)ph=48;
    var px=mx+(mW-pw)/2,py=my+(mH-ph)/2-8;
    ctx.setLineDash([7,5]);ctx.strokeStyle='rgba(255,255,255,.22)';ctx.lineWidth=1.5;
    rrect(ctx,px,py,pw,ph,6);ctx.stroke();ctx.setLineDash([]);
    rrect(ctx,px,py,pw,ph,6);ctx.fillStyle='rgba(255,255,255,.05)';ctx.fill();
    var fs=Math.max(12,Math.round(ph*.2));
    ctx.fillStyle='rgba(255,255,255,.32)';ctx.font='bold '+fs+'px Barlow Condensed,sans-serif';
    ctx.textAlign='center';ctx.textBaseline='middle';
    ctx.fillText('YOUR LOGO HERE',px+pw/2,py+ph/2-fs*.35);
    ctx.fillStyle='rgba(255,255,255,.15)';ctx.font=Math.max(9,Math.round(ph*.12))+'px Plus Jakarta Sans,sans-serif';
    ctx.fillText('Upload artwork in Step 5',px+pw/2,py+ph/2+fs*.7);
  }

  var lf=Math.max(9,Math.round(mW*.032));
  ctx.font='bold '+lf+'px Barlow Condensed,sans-serif';ctx.fillStyle='rgba(255,255,255,.28)';
  ctx.textAlign='right';ctx.textBaseline='bottom';
  ctx.fillText((S.nm||'').replace(/\u2122/g,'')+' \u2022 BEST LOGO MATS\u2122',mx+mW-7,my+mH-5);
  ctx.textAlign='left';ctx.fillText(S.szKey||'',mx+7,my+mH-5);
}

function rrect(ctx,x,y,w,h,r){ctx.beginPath();ctx.moveTo(x+r,y);ctx.lineTo(x+w-r,y);ctx.arcTo(x+w,y,x+w,y+r,r);ctx.lineTo(x+w,y+h-r);ctx.arcTo(x+w,y+h,x+w-r,y+h,r);ctx.lineTo(x+r,y+h);ctx.arcTo(x,y+h,x,y+h-r,r);ctx.lineTo(x,y+r);ctx.arcTo(x,y,x+r,y,r);ctx.closePath();}

function drawTex(ctx,type,x,y,w,h,ac){
  ctx.save();ctx.beginPath();rrect(ctx,x,y,w,h,8);ctx.clip();
  if(type==='carpet'){ctx.strokeStyle='rgba(255,255,255,.05)';ctx.lineWidth=1;for(var d=-h;d<w+h;d+=8){ctx.beginPath();ctx.moveTo(x+d,y);ctx.lineTo(x+d-h,y+h);ctx.stroke();}}
  else if(type==='waffle'||type==='waterhog'){ctx.strokeStyle='rgba(255,255,255,.08)';ctx.lineWidth=1;for(var gx=x;gx<x+w;gx+=14){ctx.beginPath();ctx.moveTo(gx,y);ctx.lineTo(gx,y+h);ctx.stroke();}for(var gy=y;gy<y+h;gy+=14){ctx.beginPath();ctx.moveTo(x,gy);ctx.lineTo(x+w,gy);ctx.stroke();}}
  else if(type==='berber'){ctx.fillStyle='rgba(255,255,255,.05)';for(var bx=x+4;bx<x+w;bx+=7)for(var by=y+4;by<y+h;by+=6){ctx.beginPath();ctx.arc(bx,by,1.5,0,Math.PI*2);ctx.fill();}}
  else if(type==='scraper'||type==='rubber'){ctx.fillStyle='rgba(255,255,255,.06)';for(var rx=x+6;rx<x+w-4;rx+=12)for(var ry=y+6;ry<y+h-4;ry+=10){ctx.beginPath();ctx.arc(rx,ry,2.5,0,Math.PI*2);ctx.fill();}}
  else if(type==='fabric'){ctx.strokeStyle='rgba(255,255,255,.05)';ctx.lineWidth=1;for(var fx=x;fx<x+w;fx+=6){ctx.beginPath();ctx.moveTo(fx,y);ctx.lineTo(fx,y+h);ctx.stroke();}for(var fy=y;fy<y+h;fy+=6){ctx.beginPath();ctx.moveTo(x,fy);ctx.lineTo(x+w,fy);ctx.stroke();}}
  else if(type==='foam'){ctx.fillStyle='rgba(255,255,255,.04)';for(var ex=x+5;ex<x+w-3;ex+=18)for(var ey=y+5;ey<y+h-3;ey+=14){ctx.beginPath();ctx.ellipse(ex,ey,6,4,0,0,Math.PI*2);ctx.fill();}}
  ctx.fillStyle=ac;ctx.globalAlpha=.15;ctx.fillRect(x,y,w,5);ctx.globalAlpha=1;ctx.restore();
}

function lighten(hex,amt){
  var r=parseInt(hex.slice(1,3),16),g=parseInt(hex.slice(3,5),16),b=parseInt(hex.slice(5,7),16);
  r=Math.min(255,r+amt);g=Math.min(255,g+amt);b=Math.min(255,b+amt);
  return '#'+(r<16?'0':'')+r.toString(16)+(g<16?'0':'')+g.toString(16)+(b<16?'0':'')+b.toString(16);
}

/* ── Render mat picker ── */
function renderMats(){
  var g=el('mat-grid');if(!g)return;
  var mats=MATS[S.use]||MATS.indoor;
  g.innerHTML=mats.map(function(m){
    var sel=m.handle===S.handle?' on':'';
    var bdg=m.badge?'<div class="mcard-bdg">'+m.badge+'</div>':'';
    var bp = getBasePrice(m.handle) || m.price;
    return '<div class="mcard'+sel+'" data-handle="'+m.handle+'" data-nm="'+encodeURIComponent(m.nm)+'" data-p="'+bp+'">'
      +'<img class="mcard-img" src="'+m.img+'" alt="'+m.nm+'" loading="lazy">'
      +'<div class="mcard-info">'+bdg
      +'<div class="mcard-nm">'+m.nm+'</div>'
      +'<div class="mcard-pr">From $'+bp+'</div>'
      +'</div></div>';
  }).join('');
}

/* ── Update all UI ── */
function updateUI(){
  var pct   = getVolDiscount(S.qty);
  var total = getDiscountedTotal(S.price, S.qty);
  var useMap={indoor:'Indoor',outdoor:'Outdoor',fatigue:'Anti-Fatigue',event:'Event/POP'};
  txt('price-out','$'+total);
  txt('btn-price','$'+total);
  txt('ch-use',useMap[S.use]||S.use);
  txt('ch-mat',S.nm||'Select a mat');
  txt('ch-sz',S.szKey||'Select size');
  txt('ch-qty','Qty: '+S.qty);
  /* Update checkout button total */
  var cb=el('checkout-btn');
  if(cb&&!cb.disabled) txt('checkout-btn-price','$'+total);

  /* Volume discount banner */
  var vb = el('vol-discount-banner');
  if (vb) {
    if (pct > 0) {
      var saved = S.price * S.qty - total;
      vb.innerHTML = '<span class="vd-badge">'+pct+'% OFF</span> Volume discount applied — you save <strong>$'+saved+'</strong>';
      vb.style.display = 'flex';
    } else {
      /* Show next tier incentive */
      var next = VOL_TIERS[1];
      vb.innerHTML = '\ud83d\udcca Order <strong>2+ mats</strong> and save 10% · 11+ saves 15% · 26+ saves 20%';
      vb.style.display = 'flex';
    }
  }

  draw();
}

/* ── Scroll to order section from product card ── */
function scrollOrder(handle,nm,use,price){
  S.handle=handle; S.nm=nm; S.use=use;
  var ub=el('use-btns');
  if(ub) ub.querySelectorAll('.ubtn').forEach(function(b){b.classList.toggle('on',b.dataset.use===use);});
  renderMats();
  renderSizes();
  /* Price = lookup for current size, or base */
  var looked = getPrice(handle, S.szKey);
  S.price = looked > 0 ? looked : getBasePrice(handle) || price;
  updateUI();
  var sec=el('order');
  if(sec){window.scrollTo({top:sec.getBoundingClientRect().top+window.scrollY-80,behavior:'smooth'});}
}

/* ── FAQ ── */
function faq(btn){var item=btn.parentElement,open=item.classList.contains('open');document.querySelectorAll('.fitem').forEach(function(i){i.classList.remove('open');});if(!open)item.classList.add('open');}

/* ── File upload ── */
function blmHandleFile(file){
  if(!file)return;
  S.file=file.name;S.fd=false;
  txt('up-ico','✅');txt('up-ttl','✅ '+file.name);txt('up-sub',"Ready \u2014 we\u2019ll use this for your proof.");
  var upBox=el('up-box');if(upBox)upBox.classList.add('done');
  var ext=file.name.split('.').pop().toLowerCase();
  if(['png','jpg','jpeg','gif','webp','svg','bmp'].indexOf(ext)>-1){
    var url=URL.createObjectURL(file);
    var img=new Image();
    img.onload=function(){S.img=img;draw();};
    img.onerror=function(){
      var reader=new FileReader();
      reader.onload=function(ev){var i=new Image();i.onload=function(){S.img=i;draw();};i.src=ev.target.result;};
      reader.readAsDataURL(file);
    };
    img.src=url;
  }else{S.img=null;txt('up-sub','\u2713 '+file.name+' received \u2014 our team will use this for your proof.');draw();}
}

/* ════════════════════════════════════════════════════════════
   INIT
════════════════════════════════════════════════════════════ */
function blmInit(){
  /* First draw — render mats, sizes, and set correct initial price */
  renderMats();
  renderSizes();
  /* Set initial price from table (CrystalPrint HD 2×3 = $245) */
  if (S.szKey) {
    var initPrice = getPrice(S.handle, S.szKey);
    if (initPrice > 0) S.price = initPrice;
  }
  updateUI();

  /* Product filter tabs */
  var tabs=el('tabs');
  if(tabs)tabs.addEventListener('click',function(e){
    var b=e.target.closest('.ftab');if(!b)return;
    tabs.querySelectorAll('.ftab').forEach(function(x){x.classList.remove('on');});b.classList.add('on');
    var cat=b.dataset.cat;
    document.querySelectorAll('.pcard').forEach(function(c){c.classList.toggle('hide',cat!=='all'&&c.dataset.cat!==cat);});
  });

  /* Use buttons */
  var ub=el('use-btns');
  if(ub)ub.addEventListener('click',function(e){
    var b=e.target.closest('.ubtn');if(!b)return;
    ub.querySelectorAll('.ubtn').forEach(function(x){x.classList.remove('on');});b.classList.add('on');
    S.use=b.dataset.use; S.handle=null; S.nm=null; S.szKey=null; S.price=0;
    renderMats(); renderSizes(); updateUI();
  });

  /* Mat cards — update price from table based on selected size */
  document.addEventListener('click',function(e){
    var mc=e.target.closest('.mcard');if(!mc)return;
    document.querySelectorAll('.mcard').forEach(function(x){x.classList.remove('on');});mc.classList.add('on');
    S.handle = mc.dataset.handle;
    S.nm     = decodeURIComponent(mc.dataset.nm);
    /* Rebuild size buttons for this mat — may auto-select first size */
    renderSizes();
    /* Price = lookup table value for selected size, or base price */
    var looked = getPrice(S.handle, S.szKey);
    S.price = looked > 0 ? looked : getBasePrice(S.handle) || parseInt(mc.dataset.p,10) || 245;
    /* Pre-fetch variants so checkout is instant */
    fetchVariants(S.handle,function(){});
    updateUI();
  });

  /* Size buttons — price comes from lookup table */
  document.addEventListener('click',function(e){
    var b=e.target.closest('.sbtn:not(.sbtn-custom)');if(!b)return;
    document.querySelectorAll('.sbtn').forEach(function(x){x.classList.remove('on');});b.classList.add('on');
    S.szKey = b.dataset.lbl;
    var looked = getPrice(S.handle, S.szKey);
    S.price = looked > 0 ? looked : (parseInt(b.dataset.p,10)||S.price);
    updateUI();
  });

  /* Qty */
  var qm=el('qm'),qp=el('qp');
  if(qm)qm.addEventListener('click',function(){S.qty=Math.max(1,S.qty-1);txt('qv',S.qty);updateUI();});
  if(qp)qp.addEventListener('click',function(){S.qty++;txt('qv',S.qty);updateUI();});

  /* Color swatches */
  var pal=el('color-palette');
  if(pal)pal.addEventListener('click',function(e){
    var sw2=e.target.closest('.swatch');if(!sw2)return;
    pal.querySelectorAll('.swatch').forEach(function(s){s.classList.remove('on');});sw2.classList.add('on');
    S.color=sw2.dataset.color;S.colorName=sw2.dataset.name;
    var ci=el('custom-color-input');if(ci)ci.value=S.color;
    txt('color-name-label',S.colorName);draw();
  });

  /* Custom color */
  var ci=el('custom-color-input');
  if(ci)ci.addEventListener('input',function(){
    S.color=this.value;S.colorName='Custom ('+this.value+')';
    pal&&pal.querySelectorAll('.swatch').forEach(function(s){s.classList.remove('on');});
    txt('color-name-label',S.colorName);draw();
  });

  /* Artwork tabs */
  var atabs=el('artwork-tabs');
  if(atabs)atabs.addEventListener('click',function(e){
    var b=e.target.closest('.atab');if(!b)return;
    atabs.querySelectorAll('.atab').forEach(function(x){x.classList.remove('on');});b.classList.add('on');
    var tab=b.dataset.tab;
    var pu=el('art-panel-upload'),pf=el('art-panel-free');
    if(tab==='upload'){if(pu)pu.style.display='';if(pf)pf.style.display='none';S.fd=false;}
    else{if(pu)pu.style.display='none';if(pf)pf.style.display='';S.fd=true;S.file='';S.img=null;draw();}
  });

  /* Upload */
  var upBox=el('up-box'),fileIn=el('file-in');
  if(upBox)upBox.addEventListener('click',function(e){if(e.target!==fileIn&&fileIn)fileIn.click();});
  if(fileIn)fileIn.addEventListener('change',function(){blmHandleFile(this.files[0]);this.value='';});
  if(upBox){
    upBox.addEventListener('dragover',function(e){e.preventDefault();this.style.borderColor='rgba(255,255,255,.6)';});
    upBox.addEventListener('dragleave',function(){if(!S.file)this.style.borderColor='';});
    upBox.addEventListener('drop',function(e){e.preventDefault();this.style.borderColor='';var f=e.dataTransfer.files[0];if(f)blmHandleFile(f);});
  }

  /* ── Checkout button ── */
  var checkoutBtn=el('checkout-btn');
  if(checkoutBtn)checkoutBtn.addEventListener('click',function(e){
    e.preventDefault();addToCart();
  });

  /* Scroll reveals */
  function reveal(){document.querySelectorAll('.reveal').forEach(function(e2){if(e2.getBoundingClientRect().top<window.innerHeight*.92)e2.classList.add('in');});}
  reveal();
  window.addEventListener('scroll',reveal,{passive:true});
  window.addEventListener('resize',draw,{passive:true});
}


/* ════════════════════════════════════════════════════════════
   MOBILE NAV — hamburger drawer
════════════════════════════════════════════════════════════ */
(function() {
  function mobileNavInit() {
    var hamburger = document.getElementById('nav-hamburger');
    var overlay   = document.getElementById('mobile-nav-overlay');
    var drawer    = document.getElementById('mobile-nav-drawer');
    var closeBtn  = document.getElementById('mobile-nav-close');
    if (!hamburger || !drawer) return;

    function openDrawer() {
      overlay.style.display = 'block';
      /* Force reflow for transition */
      overlay.offsetHeight;
      overlay.classList.add('open');
      drawer.classList.add('open');
      hamburger.classList.add('open');
      hamburger.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      overlay.classList.remove('open');
      drawer.classList.remove('open');
      hamburger.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      /* Hide overlay after transition */
      setTimeout(function(){ overlay.style.display = 'none'; }, 300);
    }

    hamburger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);

    /* Close on any drawer link click */
    drawer.querySelectorAll('.mobile-nav-link').forEach(function(a) {
      a.addEventListener('click', closeDrawer);
    });

    /* Close on Escape */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mobileNavInit);
  } else {
    mobileNavInit();
  }
})();

/* Safe init */
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',blmInit);}else{blmInit();}

/* ════════════════════════════════════════════════════════════
   CUSTOM SIZE QUOTE MODAL
════════════════════════════════════════════════════════════ */
function openCustomQuote(e) {
  if (e) e.preventDefault();

  /* Pre-fill mat style if one is selected */
  var matSel = document.getElementById('cq-mat');
  if (matSel && S.nm) {
    var opts = matSel.options;
    for (var i=0; i<opts.length; i++) {
      if (opts[i].value === S.nm) { matSel.selectedIndex = i; break; }
    }
  }

  /* Build hidden subject line */
  var subj = document.getElementById('cq-subject');
  if (subj) subj.value = 'Custom Size Quote — Best Logo Mats™' + (S.nm ? ' | ' + S.nm : '');

  document.getElementById('cq-overlay').style.display = 'block';
  document.getElementById('cq-modal').style.display   = 'flex';
  document.body.style.overflow = 'hidden';

  /* Focus first field */
  setTimeout(function(){ var w = document.getElementById('cq-width'); if(w) w.focus(); }, 100);
}

function closeCustomQuote() {
  document.getElementById('cq-overlay').style.display = 'none';
  document.getElementById('cq-modal').style.display   = 'none';
  document.body.style.overflow = '';
}

/* Close on Escape key */
document.addEventListener('keydown', function(e){
  if (e.key === 'Escape') closeCustomQuote();
});

/* Wire up quote form submit — build body from fields */
document.addEventListener('DOMContentLoaded', function(){
  var cqForm = document.getElementById('cq-form');
  if (!cqForm) return;
  cqForm.addEventListener('submit', function(){
    /* Build a clean body from the fields */
    var w   = (document.getElementById('cq-width')||{}).value  || '';
    var l   = (document.getElementById('cq-length')||{}).value || '';
    var mat = (document.getElementById('cq-mat')||{}).value    || '';
    var qty = (document.getElementById('cq-qty')||{}).value    || '1';
    var nm  = (document.getElementById('cq-name')||{}).value   || '';
    var em  = (document.getElementById('cq-email')||{}).value  || '';
    var notes=(document.getElementById('cq-notes')||{}).value  || '';

    var body = [
      'CUSTOM SIZE QUOTE REQUEST \u2014 BEST LOGO MATS\u2122',
      '===========================================',
      'Size:     ' + w + '" \xd7 ' + l + '"  (' + Math.round(w/12*10)/10 + "\u2019 \xd7 " + Math.round(l/12*10)/10 + '\u2019)',
      'Mat Type: ' + mat,
      'Quantity: ' + qty,
      '===========================================',
      'Name:     ' + nm,
      'Email:    ' + em,
      (notes ? 'Notes:    ' + notes : ''),
      '\u2014 Submitted via bestlogomats.com custom size form'
    ].filter(Boolean).join('\n');

    var bodyField = cqForm.querySelector('textarea[name="contact[body]"]');
    if (bodyField) bodyField.value = body;

    var subjField = document.getElementById('cq-subject');
    if (subjField) subjField.value = 'CUSTOM QUOTE: ' + w + '" \xd7 ' + l + '" ' + mat + ' x' + qty + ' | ' + nm;
  });

  /* Show success if redirected back */
  if (window.location.search.indexOf('quote=sent') > -1) {
    var contactSec = document.getElementById('contact');
    if (contactSec) {
      var banner = document.createElement('div');
      banner.style.cssText = 'background:#dcfce7;border:2px solid #16a34a;border-radius:10px;padding:16px 20px;margin-bottom:18px;color:#166534;font-size:.95rem;font-weight:600;text-align:center';
      banner.textContent = '\u2705 Quote request received! We\u2019ll send you pricing within a few hours.';
      contactSec.insertBefore(banner, contactSec.querySelector('.contact-inner'));
      contactSec.scrollIntoView({behavior:'smooth', block:'center'});
    }
  }
});

/* ════════════════════════════════════════════════════════════
   STICKY CTA BAR — show after hero, hide near order section
════════════════════════════════════════════════════════════ */
(function() {
  function stickyCtaInit() {
    var bar    = document.getElementById('sticky-cta-bar');
    var hero   = document.querySelector('.hero');
    var order  = document.getElementById('order');
    if (!bar || !hero) return;

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        ticking = false;
        var heroBottom  = hero.getBoundingClientRect().bottom;
        var orderTop    = order ? order.getBoundingClientRect().top : 9999;
        var orderBottom = order ? order.getBoundingClientRect().bottom : 9999;

        /* Show after hero scrolls out of view */
        var shouldShow = heroBottom < 0;
        /* Hide while the order section is on screen (user is already configuring) */
        var nearOrder = orderTop < window.innerHeight && orderBottom > 0;

        if (nearOrder) {
          bar.classList.remove('visible');
          bar.setAttribute('aria-hidden', 'true');
        } else if (shouldShow) {
          bar.classList.add('visible');
          bar.setAttribute('aria-hidden', 'false');
        } else {
          bar.classList.remove('visible');
          bar.setAttribute('aria-hidden', 'true');
        }
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); /* run once on load */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stickyCtaInit);
  } else {
    stickyCtaInit();
  }
})();

/* ════════════════════════════════════════════════════════════
   STEP COMPLETION INDICATORS
   Watches S state and marks steps done as user progresses
════════════════════════════════════════════════════════════ */
function updateStepDone() {
  var steps = [
    { n:1, done: !!S.use },
    { n:2, done: !!S.handle },
    { n:3, done: !!S.szKey },
    { n:4, done: !!S.color },
    { n:5, done: !!(S.file || S.fd) }
  ];
  steps.forEach(function(step) {
    var badge = document.getElementById('step-done-' + step.n);
    var num   = document.getElementById('step-num-'  + step.n);
    if (!badge) return;
    if (step.done) {
      badge.classList.add('show');
      if (num) num.classList.add('done');
    } else {
      badge.classList.remove('show');
      if (num) num.classList.remove('done');
    }
  });
}

/* Patch updateUI to also run step done check */
var _origUpdateUI = updateUI;
updateUI = function() {
  _origUpdateUI();
  updateStepDone();
};

/* Also fire on artwork upload/free-design selection */
document.addEventListener('DOMContentLoaded', function() {
  var atabs = document.getElementById('artwork-tabs');
  if (atabs) atabs.addEventListener('click', function() {
    setTimeout(updateStepDone, 50);
  });
  var fileIn = document.getElementById('file-in');
  if (fileIn) fileIn.addEventListener('change', function() {
    setTimeout(updateStepDone, 100);
  });
});

/* ════════════════════════════════════════════════════════════
   LOCALSTORAGE STATE PERSISTENCE
   Saves & restores configurator selections across page loads
════════════════════════════════════════════════════════════ */
var BLM_STORE_KEY = 'blm_config_v1';

function saveState() {
  try {
    var data = {
      use:       S.use,
      handle:    S.handle,
      nm:        S.nm,
      szKey:     S.szKey,
      price:     S.price,
      qty:       S.qty,
      color:     S.color,
      colorName: S.colorName,
      fd:        S.fd,
      file:      S.file,
      ts:        Date.now()
    };
    localStorage.setItem(BLM_STORE_KEY, JSON.stringify(data));
  } catch(e) { /* localStorage unavailable — silently skip */ }
}

function loadState() {
  try {
    var raw = localStorage.getItem(BLM_STORE_KEY);
    if (!raw) return false;
    var data = JSON.parse(raw);
    /* Expire after 2 hours */
    if (!data.ts || Date.now() - data.ts > 7200000) {
      localStorage.removeItem(BLM_STORE_KEY);
      return false;
    }
    /* Restore state */
    if (data.use)       S.use       = data.use;
    if (data.handle)    S.handle    = data.handle;
    if (data.nm)        S.nm        = data.nm;
    if (data.szKey)     S.szKey     = data.szKey;
    if (data.price)     S.price     = data.price;
    if (data.qty)       S.qty       = data.qty;
    if (data.color)     S.color     = data.color;
    if (data.colorName) S.colorName = data.colorName;
    if (data.fd)        S.fd        = data.fd;
    if (data.file)      S.file      = data.file;
    return true;
  } catch(e) { return false; }
}

/* Auto-save on every meaningful state change */
function patchSave() {
  /* Wrap qty button listeners */
  var qm = document.getElementById('qm');
  var qp = document.getElementById('qp');
  if (qm) { var _qm = qm.onclick; qm.addEventListener('click', saveState); }
  if (qp) { var _qp = qp.onclick; qp.addEventListener('click', saveState); }

  /* Debounced save on any click in the order section */
  var order = document.getElementById('order');
  if (order) {
    order.addEventListener('click', function() {
      clearTimeout(window._blmSaveTimer);
      window._blmSaveTimer = setTimeout(saveState, 400);
    });
  }

  /* Save on color picker change */
  var ci = document.getElementById('custom-color-input');
  if (ci) ci.addEventListener('change', saveState);
}

/* Restore UI to match saved state */
function restoreUI() {
  /* Use button */
  var ub = document.getElementById('use-btns');
  if (ub && S.use) {
    ub.querySelectorAll('.ubtn').forEach(function(b) {
      b.classList.toggle('on', b.dataset.use === S.use);
    });
  }

  /* Color swatch */
  var pal = document.getElementById('color-palette');
  if (pal && S.color) {
    pal.querySelectorAll('.swatch').forEach(function(sw) {
      sw.classList.toggle('on', sw.dataset.color === S.color);
    });
    var ci = document.getElementById('custom-color-input');
    if (ci) ci.value = S.color;
    var lbl = document.getElementById('color-name-label');
    if (lbl) lbl.textContent = S.colorName || S.color;
  }

  /* Qty */
  var qv = document.getElementById('qv');
  if (qv) qv.textContent = S.qty;

  /* Free design notes */
  if (S.fd) {
    var atabs = document.getElementById('artwork-tabs');
    if (atabs) {
      atabs.querySelectorAll('.atab').forEach(function(b) {
        b.classList.toggle('on', b.dataset.tab === 'free');
      });
      var pu = document.getElementById('art-panel-upload');
      var pf = document.getElementById('art-panel-free');
      if (pu) pu.style.display = 'none';
      if (pf) pf.style.display = '';
    }
  }
}

/* Bolt into blmInit — run after normal init */
var _origInit = blmInit;
blmInit = function() {
  var hadSaved = loadState();
  _origInit();
  if (hadSaved) {
    restoreUI();
    /* Show subtle "restored" toast */
    setTimeout(function() {
      var bar = document.createElement('div');
      bar.style.cssText = 'position:fixed;bottom:80px;left:50%;transform:translateX(-50%);background:#0d2461;color:#fff;font-size:.78rem;font-weight:600;padding:9px 18px;border-radius:8px;z-index:600;box-shadow:0 4px 18px rgba(0,0,0,.3);white-space:nowrap;pointer-events:none;opacity:0;transition:opacity .3s';
      bar.textContent = '\u2713 Your previous selections restored';
      document.body.appendChild(bar);
      setTimeout(function(){ bar.style.opacity='1'; }, 50);
      setTimeout(function(){ bar.style.opacity='0'; setTimeout(function(){ bar.remove(); }, 350); }, 2800);
    }, 800);
  }
  patchSave();
};
